import React from "react";
import { InvitationTokenContext } from "./InvitationTokenContext.js";

export function useInvitationToken() {
  return React.useContext(InvitationTokenContext);
}
